import {useEffect, useState} from "react";
import {OrganizationCtrl} from "../../../controllers/OrganizationCtrl";
import {CuppaStorage} from "../../../../cuppa/cuppa.storage";
import {Storages} from "../../../controllers/Storages";
import {cuppa, log} from "../../../../cuppa/cuppa";
import {GetStorage} from "../../../../cuppa/reactComponents/GetStorage";
import {Constants} from "../../../controllers/Constants";

export function OrganizationsSelector(){
	const [organizations, setOrganizations] = useState([]);
	const [organization, setOrganization] = useState();

	useEffect(()=>{
		loadOrganizations().then();
	}, [])

	async function loadOrganizations(){
		let user = await CuppaStorage.getData(Storages.user);
		let organizations = await OrganizationCtrl.loadUserOrganizations({userId:user.id, status:Constants.organizationStatuses.ACTIVE});
		organizations = cuppa.arrayObjectSort(organizations?.data?.userOrganizations, 'name');
		setOrganizations(organizations);
	}

	function onChange(e){
		OrganizationCtrl.switchOrganization({id:e.target.value}).then();
	}
	return(
		<>
			<GetStorage {...Storages.organization} callback={setOrganization} />
			<select
				className={`input2 m-l-0-s1100 m-r-0-s1100 `}
				value={organization?.id}
				style={{maxWidth:200}}
				onChange={onChange}
			>
				{organizations.map(organization=>{
					return <option key={organization.id} value={organization.id}>{organization.name}</option>
				})}
			</select>
		</>
	)
}


